import {
  HIDE_MODAL,
  SHOW_MODAL
} from '../actions/action-types';

export const activeModal = (state = { modalName: null, params: {} },
                            action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalName: action.modalName,
        params: action.modalParams || {}
      };
    case HIDE_MODAL:
      return {
        modalName: null,
        params: {}
      };
    default:
      return state;
  }
};
